export default "__VITE_ASSET__yyYf$UHY__"